module.exports = __webpack_public_path__ + "static/media/login.7ca2c126.svg";